/**
 * CAPA lifecycle — structured phases (purpose, actions, data, roles).
 * Status strings in capaWorkflow.js must match `stage` exactly.
 */

export const CAPA_LIFECYCLE_PHASES = [
  {
    stage: "Open",
    purpose: "CAPA is created and the issue is logged.",
    actions: [
      "Create CAPA",
      "Capture issue context",
      "Save initial CAPA record",
    ],
    data: [
      "Title",
      "Description",
      "Issue type",
      "Study / project reference",
      "Severity",
    ],
    who: "User / QA / Auditor",
  },
  {
    stage: "Under Investigation",
    purpose: "Collect investigation details and assign investigator.",
    actions: [
      "Fill investigation details",
      "Assign investigator",
      "Submit investigation",
    ],
    data: [
      "Investigation details",
      "Investigator (assigned to)",
      "Investigation date",
    ],
    who: "Investigator / QA",
  },
  {
    stage: "Under RCA",
    purpose: "Document and submit validated root cause.",
    actions: [
      "Fill root cause description",
      "Select RCA method (5 Why / Fishbone)",
      "Submit RCA",
    ],
    data: [
      "Root cause description",
      "RCA method",
      "Supporting notes",
    ],
    who: "Investigator / Subject matter expert",
  },
  {
    stage: "Action Planning",
    purpose: "Define corrective and preventive action plans.",
    actions: [
      "Add corrective action",
      "Add preventive action",
      "Submit action plan",
    ],
    data: [
      "Corrective action description / owner / due date",
      "Preventive action description / owner / due date",
    ],
    who: "Owner / Assigned team",
  },
  {
    stage: "Approved",
    purpose: "Action plan approved by QA/manager.",
    actions: [
      "Review action plan",
      "Approve plan",
    ],
    data: [
      "Approver",
      "Approved by",
      "Approval date",
      "Approval comments",
    ],
    who: "QA head / Manager",
  },
  {
    stage: "Implementation",
    purpose: "Execute approved corrective and preventive actions.",
    actions: [
      "Perform corrective actions",
      "Implement preventive controls",
      "Mark completed with evidence",
    ],
    data: [
      "Action status",
      "Completion date",
      "Evidence / comments",
    ],
    who: "Assigned users",
  },
  {
    stage: "Verification",
    purpose: "QA verifies CAPA effectiveness.",
    actions: [
      "Submit verification result",
      "If not effective, send back to action planning",
    ],
    data: [
      "Verification result (Effective / Not Effective)",
      "Verified by",
      "Remarks",
    ],
    who: "QA / Auditor",
  },
  {
    stage: "Closure",
    purpose:
      "Final stage: add final remarks and attachments, then close. The CAPA status becomes Closed when closure is completed.",
    actions: [
      "Save final remarks and attachments",
      "Close CAPA (status becomes Closed)",
    ],
    data: [
      "Final remarks",
      "Closure attachments",
      "Closed by / date (on record)",
    ],
    who: "QA / Management",
  },
];
